import { render, staticRenderFns } from "./VehicleList.vue?vue&type=template&id=50b75ed2&scoped=true"
import script from "./VehicleList.vue?vue&type=script&lang=js"
export * from "./VehicleList.vue?vue&type=script&lang=js"
import style0 from "./VehicleList.vue?vue&type=style&index=0&id=50b75ed2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b75ed2",
  null
  
)

export default component.exports